import { TablePagination } from '@mui/material';
import { ChangeEvent as ReactChangeEvent, MouseEvent as ReactMouseEvent, useCallback } from 'react';
import { TableInstance } from 'react-table';
import { QuotesSummaryItem } from 'shared/types/quotesSummary';

interface QuotesSummaryTablePaginationProps {
  instance: TableInstance<QuotesSummaryItem>;
  totalCount: number;
}
export function QuotesSummaryTablePagination({ instance, totalCount }: QuotesSummaryTablePaginationProps) {
  const {
    state: { pageIndex, pageSize },
    gotoPage,
    setPageSize,
  } = instance;
  const handlePageChange = useCallback(
    (_: ReactMouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => {
      gotoPage(page);
    },
    [gotoPage]
  );

  const handleRowsPerPageChange = useCallback(
    (event: ReactChangeEvent<HTMLInputElement>) => {
      setPageSize(Number(event.target.value));
      gotoPage(0);
    },
    [setPageSize, gotoPage]
  );

  return (
    <TablePagination
      component='div'
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      page={pageIndex}
      rowsPerPageOptions={[15, 25, 50, 100]}
      count={totalCount}
      rowsPerPage={pageSize}
    />
  );
}
